import React, { useEffect } from 'react';
import Layout from '../../components/Layout/Layout';
import RefundPolicy from '../../components/RefundPolicy/RefundPolicy';

const RefundPolicyPage = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<Layout title="Política de Reembolso">
			<RefundPolicy />
		</Layout>
	);
};

export default RefundPolicyPage;
